import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SiteRoadwaysSliceState } from "../types";

const initialState: SiteRoadwaysSliceState = {
  propertyType: '',
  siteLocation: 0,
  location_type_id: "",
  service_road_type_id: "",
  questionList: [],
  othersPropertyType: "",
  land_acquired_extent: "",
  area_acquired: "",
  service_road_length: "",
  total_traffic_per_day: "",
  is_previously_approved: null,
  is_constructed_without_prior_permission: null,
  is_facility_operational: null,
  is_part_of_rest_area: null,
  is_service_road_provided: null,
  on_slip_road: null,
  access_criteria_met: null,
  is_coco_fuel_station:null,
  is_located_on_service_road: null,
  meets_general_access_requirements: null,
  selectedQuestions: [],
  question_true: [],
  question_false: [],

  //new added 
  category_id: 0,
  property_type_id: 0,  
  loi_name: "",
  loi_dealer_name: "",
  loi_number: "",
  loi_date: "",
  plot_length_m: "",
  plot_width_m: "",
  plot_area: "",   
  min_service_road_merging_distance_m: "",
  distance_between_access_road_same_carriageway: "",
  distance_between_access_roads_m: "",
  check_barrier_distance: "",
  distance_from_rob_flyover_m: "",
  entrance_or_exit_width: "",
  turning_curve_radius: "",
  non_turning_curve_radius: "",
  acceleration_width: "",
  deceleration_width: "",
  service_road_width: "",
  access_connection_crust_composition: "",
  access_road_downward_slope: "",
  distance_between_access_road_same_side: "",
  distance_from_nearest_intersection: "",
  distance_from_toll_plaza: "",
  distance_from_start_rob: "",
  start_distance_from_flyover: "",
  fuel_station_carriageway_type: "",
  carriageway_fs_distance: "", 
  undivided_carriageway_distance_from_fs: "",
  divided_carriageway_distance_from_fs: "",
  highway_gradient_section: "",
  fuel_station_slope_percentage: "",
  buffer_strip_length: "",
  buffer_strip_width: "",
  kerb_height: "",
  nh_access_area_diff: "",
  acceleration_length: "",
  deceleration_length: "",
  nearest_intersection_length: "",
  service_road_provision_length: "",
  highway_gradient_percent: "",
  slope_premise_percent: "",
  num_of_cultivates: null,
};

const SiteRoadwaysStateSlice = createSlice({
  name: "SiteRoadwaysSlice",
  initialState,
  reducers: {
    setSiteRoadwaysField(state: any, action) {
      const { name, value } = action.payload;
      state[name] = value;
    },
    setSiteRoadwaysAccessField: (
      state,
      action: PayloadAction<{
        name: keyof SiteRoadwaysSliceState | string;
        value: any;
      }>
    ) => {
      (state as any)[action.payload.name] = action.payload.value;
    },
    setQuestionList(state, action) {
      state.questionList = action.payload;
    },
    setQuestionAnswer(state, action) {
      const { questionId, value } = action.payload;
      const updateAnswer = (questions: any[]) => {
        questions.forEach(q => {
          if (q.id === Number(questionId)) {
            q.answer = value;
          }
          if (q.children && q.children.length > 0) {
            updateAnswer(q.children);
          }
        });
      };
      updateAnswer(state.questionList);
    },
    resetSiteRoadWaysState(state) {
      Object.assign(state, initialState);
    },

  },
});

export const { setSiteRoadwaysField, setQuestionList, setQuestionAnswer, resetSiteRoadWaysState, setSiteRoadwaysAccessField } = SiteRoadwaysStateSlice.actions;
export default SiteRoadwaysStateSlice.reducer;
